import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPMachineryChecklistTableDataAPI = createAsyncThunk("STPMachineryChecklistTableData", async ({ data }) => {
    const {
        ReadingDate,
        M_STP_MachEquipmentTypeID,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        handleSTPMachineryChecklistExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_MachineryCheckList_Select?ReadingDate=${ReadingDate}&M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_MachEquipmentTypeID=${M_STP_MachEquipmentTypeID ? M_STP_MachEquipmentTypeID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSTPMachineryChecklistExport && handleSTPMachineryChecklistExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPMachineryChecklistTableDataSlice = createSlice({
    name: "STPMachineryChecklistTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryChecklistTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPMachineryChecklistTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPMachineryChecklistTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryChecklistTableDataReducer = STPMachineryChecklistTableDataSlice.reducer

export const STPMachineryChecklistTableExportDataAPI = createAsyncThunk("STPMachineryChecklistTableExportData", async ({ data }) => {
    const {
        ReadingDate,
        M_STP_MachEquipmentTypeID,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_MachineryCheckList_Select?ReadingDate=${ReadingDate}&M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_MachEquipmentTypeID=${M_STP_MachEquipmentTypeID ? M_STP_MachEquipmentTypeID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPMachineryChecklistExportDataSlice = createSlice({
    name: "STPMachineryChecklistExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryChecklistTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPMachineryChecklistTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPMachineryChecklistTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryChecklistTableExportDataReducer = STPMachineryChecklistExportDataSlice.reducer


export const STPMachineryChecklistPostDataAPI = createAsyncThunk("STPMachineryChecklistPostData", async ({ data }) => {
    const {
        T_STP_MachineryCheckListID,
        M_STP_MachineryActionsID,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_STP_MachineryCheckListID", T_STP_MachineryCheckListID);
    formdata.append("M_STP_MachineryActionsID", M_STP_MachineryActionsID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/Post_WEB_STP_T_STP_MachineryCheckList_Update`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPMachineryChecklistPostDataSlice = createSlice({
    name: "STPMachineryChecklistPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMachineryChecklistPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPMachineryChecklistPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPMachineryChecklistPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPMachineryChecklistPostDataReducer = STPMachineryChecklistPostDataSlice.reducer

// -----------------Delete API ---------------

// export const STPMachineryOperationDeleteAPI = createAsyncThunk("STPMachineryOperationDelete", async ({ data }) => {
//     const {
//         T_STP_MachineryOperationID,
//         M_UserID,
//         token,
//         handleIsPost
//     } = data

//     var myHeaders = new Headers();
//     myHeaders.append("Authorization", "Bearer " + token);


//     var formdata = new FormData();
//     formdata.append("T_STP_MachineryOperationID", T_STP_MachineryOperationID);
//     formdata.append("M_UserID", M_UserID);

//     var requestOptions = {
//         method: 'DELETE',
//         headers: myHeaders,
//         body: formdata,
//         redirect: 'follow'
//     };

//     fetch(`${BaseUrl}/APKDashboard/WEB_STP_T_STP_MachineryOperation_Delete`, requestOptions)
//         .then((res) => res.json())
//         .then((result) => {
//             if (result.status) {
//                 handleIsPost()
//                 toastSuccesss(result.message)
//             } else {
//                 toastErrorr(result.message)

//             }
//             return result

//         })
// })

// const STPMachineryOperationDeleteSlice = createSlice({
//     name: "STPMachineryOperationDelete",
//     initialState: {
//         isDeleteLoading: false,
//         SectorData: null,
//         isError: false,
//     },
//     extraReducers: (builder) => {
//         builder.addCase(STPMachineryOperationDeleteAPI.pending, (state, action) => {
//             state.isDeleteLoading = true;
//         });
//         builder.addCase(STPMachineryOperationDeleteAPI.fulfilled, (state, action) => {
//             state.isDeleteLoading = false;
//             state.SectorData = action.payload;

//         });
//         builder.addCase(STPMachineryOperationDeleteAPI.rejected, (state, action) => {
//             console.log("Error", action.payload);
//             state.isDeleteLoading = false;
//             state.isError = true;
//             state.SectorData = null;
//             // toastErrorr('Something went wrong')
//         });
//     },
// })

// export const STPMachineryOperationDeleteReducer = STPMachineryOperationDeleteSlice.reducer